import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LivingRoom from "../pages/living-room/page";
import CozyCorners from "../pages/cozy-corners/page";
import StyleGuide from "../pages/style-guide/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import SoftBeige from "../pages/living-room/soft-beige/page";
import ReadingCorner from "../pages/cozy-corners/reading-corner/page";
import BestBeigeSofas from "../pages/cozy-corners/best-beige-sofas/page";
import NeutralRugs from "../pages/products/neutral-rugs/page";
import LinenCurtains from "../pages/products/linen-curtains/page";
import WoodCoffeeTables from "../pages/products/wood-coffee-tables/page";
import BeigeThrowPillows from "../pages/products/beige-throw-pillows/page";
import SmallApartmentSoftNeutrals from "../pages/living-room/small-apartment-soft-neutrals/page";
import CalmBedroomNeutrals from "../pages/bedroom/calm-bedroom-neutrals/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/living-room", element: <LivingRoom /> },
  { path: "/living-room/soft-beige", element: <SoftBeige /> },
  { path: "/cozy-corners", element: <CozyCorners /> },
  { path: "/cozy-corners/reading-corner", element: <ReadingCorner /> },
  { path: "/cozy-corners/best-beige-sofas", element: <BestBeigeSofas /> },
  { path: "/products/neutral-rugs", element: <NeutralRugs /> },
  { path: "/products/linen-curtains", element: <LinenCurtains /> },
  { path: "/products/wood-coffee-tables", element: <WoodCoffeeTables /> },
  { path: "/products/beige-throw-pillows", element: <BeigeThrowPillows /> },
  { path: "/living-room/small-apartment-soft-neutrals", element: <SmallApartmentSoftNeutrals /> },
  { path: "/bedroom/calm-bedroom-neutrals", element: <CalmBedroomNeutrals /> },
  { path: "/style-guide", element: <StyleGuide /> },
  { path: "/about", element: <About /> },
  { path: "/contact", element: <Contact /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
